import React from 'react';
import s from './header.module.css';
export var Header = function () {
    return (React.createElement("header", { className: s.header },
        React.createElement("div", { className: s.headerLogoContainer },
            React.createElement("img", { src: "https://icons.multifarm.fi/other/bastion-logo.png", alt: "Bastion Logo" }),
            React.createElement("h1", { className: s.headerTitle }, "Bastion"))));
};
